<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta Mastercard
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Vamos a generar tu tarjeta</label> 
                    </div>
                </div>   
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label v-text="model.message"></label> 
                    </div>
                </div>   
                <div class="row" style="margin-top:10px;margin-bottom:30px;">
                    <img src="@/assets/generarcard.png" class="mx-auto d-block" width="20%" height="20%" />
                </div>
                <div class="row form-group" >
                    <div class="col-md-12 text-center">
                        <save-button text="Continuar" @click="continuar"></save-button>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';

    export default {
        components: { 
        },
        data(){
            return{
                model: { 
                    message: "",                 
                },
            }
        },
        mounted() {
            let context = this;
            context.model.message = "Necesitamos que nos brindes algunos datos adicionales para poder gestionar tu tarjeta. Para poder comenzar el pedido tenés que tener al menos $" + context.$store.getters.SaldoReservaMastercard  + " en tu cuenta que serán retenidos y te los acreditaremos en tu tarjeta cuando esté lista para que los uses donde quieras.";
        },
        methods: {
            continuar() {
                let context = this
                let req = { };

                axiosHelpers.axiosPost('Mastercard/ValidateBankBalanceToGenerateTheCard', req, this, function(data)
                { 
                    if(data.ResponseVM.Result)
                    {
                        context.$router.push("GenerateCard");                                                
                    }
                });
            }
        }
    }
</script>